import { getListContainer, getToolbar } from './clientInspectionUtils';

const toolbarWithPopoverClass = 'toolbar-with-popover';

export function enableToolbarOverflow() {
  const listContainer = getListContainer();

  // fix the width to match the calculated width (when overflow hidden)
  listContainer.style.width = `${listContainer.clientWidth}px`;

  // adjust the margin to match the scroll position
  if (listContainer.scrollLeft > 0) {
    listContainer.style.marginLeft = `-${listContainer.scrollLeft}px`;
  }

  const toolbar = getToolbar();
  toolbar.classList.add(toolbarWithPopoverClass);
}

export function disableToolbarOverflow() {
  const listContainer = getListContainer();
  listContainer.style.width = '';
  listContainer.style.marginLeft = '';

  const toolbar = getToolbar();
  toolbar.classList.remove(toolbarWithPopoverClass);
}
